import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { Organization } from '@types';
import { openCheckout } from '../../services/paddleService';

const MsaPaymentCheckout: React.FC<{ organization: Organization; email: string; label?: string; frameTarget?: string }> = ({ organization, email, label = 'Set Up Payment', frameTarget }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const open = async () => {
        setLoading(true);
        setError('');
        try {
            const callable = httpsCallable(getFunctions(undefined, 'us-central1'), 'prepareMsaPayment');
            const result = (await callable({})).data as { items: Array<{ priceId: string; quantity: number }>; trialEndsAt?: string; customerId?: string; payerEmail?: string };
            await openCheckout({
                items: result.items,
                customerId: result.customerId || organization.paddleCustomerId || undefined,
                customer: { email: result.payerEmail || organization.ownerEmail || email },
                customData: { organization_id: organization.id, msa_application_id: organization.msaApplicationId, msa_payment_setup: true, msa_trial_ends_at: result.trialEndsAt || '' },
                settings: { displayMode: frameTarget ? 'inline' : 'overlay', theme: 'light', showAddDiscounts: false, ...(frameTarget ? { frameTarget, frameInitialHeight: 450, frameStyle: 'width:100%;min-width:312px;background:transparent;border:none;' } : { successUrl: `${window.location.origin}/dashboard?checkout=success` }) },
            });
        } catch (failure: any) {
            setError(failure.message || 'Payment setup could not start.');
        } finally {
            setLoading(false);
        }
    };
    return <div><button type="button" onClick={() => void open()} disabled={loading} className="rounded-xl bg-blue-600 px-6 py-3 text-sm font-extrabold text-white hover:bg-blue-700 disabled:opacity-50">{loading ? 'Opening checkout…' : label}</button>{error && <p className="mt-2 text-sm font-semibold text-red-700">{error}</p>}</div>;
};

export default MsaPaymentCheckout;
